import { createSlice } from '@reduxjs/toolkit';

import { createTag } from '@/domain/tags/actions/create-tag.action.ts';
import { getTags } from '@/domain/tags/actions/get-tags.action.ts';

import { Tag } from './entities/tag.entity';

export type TagsState = {
  tags: Array<Tag>;
};

const initialState: TagsState = {
  tags: [],
};

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getTags.pending, (state) => {
        state.tags = [];
      })
      .addCase(getTags.fulfilled, (state, action) => {
        state.tags = action.payload;
      })
      .addCase(getTags.rejected, (state) => {
        state.tags = [];
      })

      .addCase(createTag.fulfilled, (state, action) => {
        state.tags.push(action.payload);
      });
  },
});
